module.exports = {
    en: {
        cars: {
            text: 'Cars',
        }

    },
    ka: {
        cars: {
            text: 'მანქანები',
        }
    },
    ru: {
        cars: {
            text: 'автомобили',
        }
    }
}